import { useContext } from "react";
import type { RunDialogPageProps } from "..";
import { RunWithContext } from "../../api-playground/run-with";
import AuthToken from "../../auth-token";
import { useRunDialogContext } from "../context";
import LearnMoreCurl from "../learn-more-curl.mdx";
import LearnMoreJavaScript from "../learn-more-javascript.mdx";
import LearnMorePython from "../learn-more-python.mdx";
import { MDXPageWithToc } from "../mdx-page-with-toc";
import { GettingStartedContext } from "../snippets";

export function LearnMorePage({ token, version }: RunDialogPageProps) {
  const { language } = useRunDialogContext();

  const Content = (() => {
    switch (language) {
      case RunWithContext.NodeJS:
        return LearnMoreJavaScript;
      case RunWithContext.Python:
        return LearnMorePython;
      case RunWithContext.HTTP:
        return LearnMoreCurl;
      default:
        throw new Error(`Unexpected language: ${language}`);
    }
  })();

  const gsp = useContext(GettingStartedContext);

  return (
    <MDXPageWithToc language={language} id="learn-more">
      <Content
        components={{
          AuthToken: AuthToken,
        }}
        // @ts-ignore
        token={token}
        version={version}
        {...gsp}
      />
    </MDXPageWithToc>
  );
}
